import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CheckoutContentExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import {
  CheckoutContentFormValue,
  ExtensionToCssBorderRadius,
  ExtensionToCssBorderType,
  ExtensionToCssBorderWidth,
  ExtensionToCssPadding,
} from '../../../extension-components/checkout-content/checkout-content.utils';
import { ViewMode } from '../../../../models';
import { CHECKOUT_CONTENT_TIMER_PLACEMENTS } from '@pdqdev/pdq-shared/dist/utils/extensions-timer-utils';

@Component({
  selector: 'checkout-content-example',
  templateUrl: './checkout-content-example.component.html',
  styleUrls: ['./checkout-content-example.component.scss'],
  standalone: false,
})
export class CheckoutContentExampleComponent implements OnInit, OnChanges {
  @Input() template: CheckoutContentFormValue;
  @Input() mode: ViewMode = null;
  @Input() isMobile: boolean = false;

  StyleType = CheckoutContentExtension.StyleType;
  BlockType = CheckoutContentExtension.BlockType;
  BlockMode = CheckoutContentExtension.BlockMode;
  readonly TIMER_PLACEMENTS = CHECKOUT_CONTENT_TIMER_PLACEMENTS;
  containerStyle;
  blockStyle;

  get timerConfiguration() {
    return this.template?.timerConfiguration;
  }

  constructor() {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.template) {
      this.initStyles();
    }
  }
  ngOnInit(): void {
    this.initStyles();
  }

  private initStyles() {
    this.containerStyle = {
      padding: ExtensionToCssPadding.get(this.template.general.padding),
      'border-radius': ExtensionToCssBorderRadius.get(this.template.general.cornerRadius),
      'border-width': ExtensionToCssBorderWidth.get(this.template.general.borderWidth),
      'border-style': ExtensionToCssBorderType.get(this.template.general.border),
      'border-color': '#dedede',
    };

    switch (this.template.general.styleType) {
      case CheckoutContentExtension.StyleType.ROWS:
        this.blockStyle = {
          'max-height': 100 / this.template.blocks.length + '%',
        };
        break;
      case CheckoutContentExtension.StyleType.COLUMNS:
        this.blockStyle = {
          'max-width': 100 / this.template.blocks.length + '%',
        };
        break;
    }
  }
}
